import React, { Component } from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import { Link, withRouter } from 'react-router'
import classNames from 'classnames';
import { Field } from 'redux-form';
import { Grid, Row, Col, Panel, Button, Input, DropdownButton, MenuItem, InputWarehouse } from 'react-bootstrap';
import Spinner from '../../components/Widgets/spinner';
import InputField from '../Common/inputField';
import { Translate, Localize } from 'react-redux-i18n';
import checkPermission from '../Common/permissions';
//import {buttonStyle, marginTopStyle, centerStyle} from '../Common/style'



class WarehouseForm extends Component {
    // static contextTypes = {
    //     router: React.PropTypes.object
    // };
    //
    // constructor() {
    //     super();
    //     this.state = {
    //         dirty: false
    //     };
    // }

    // componentDidMount() {
    //     // making a leaving hook to confirm leaving
    //     this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
    //
    //     if (this.props.currentWarehouse) this.props.fetchWarehouseDetail(this.props.currentWarehouse);
    // }

    handleFormSubmit(formProps) {
        // this.setState({ dirty: false });
        if (this.props.currentWarehouse) this.props.editWarehouse(formProps);
        else this.props.createWarehouse(formProps);
    }

    // componentWillReceiveProps(nextProps) {
    //     if (nextProps.dirty != this.props.dirty) {
    //         this.setState({
    //             dirty: nextProps.dirty
    //         });
    //     }
    // }

    // routerWillLeave(nextLocation) {
    //     if (this.state.dirty) return <Translate value="work_not_saved_warning" />
    // }

    // title() {
    //     if (this.props.currentWarehouse) return <Translate value="warehouse_detail_view" />| <Translate value="edit_warehouse" />;
    //     else return <Translate value="warehouse_detail_view" /> | <Translate value="create_warehouse" />;
    // }

    renderForm() {
        return (
              <Row>
                  <Col sm={ 2 } />
                  <Col sm={ 4 }>
                      <Row><Col sm={ 12 }><label><Translate value="warehouse_name" /> (*) </label></Col></Row>
                      <Row><Col sm={ 12 }><Field name="Name" component={ InputField } /></Col></Row>
                      <Row><Col sm={ 12 }><label><Translate value="address" /> (*) </label></Col></Row>
                      <Row><Col sm={ 12 }><Field name="Street" component={ InputField } placeholder="Street"/></Col></Row>
                      <Row><Col sm={ 12 }><Field name="City" component={ InputField } placeholder="City"/></Col></Row>
                      <Row>
                          <Col sm={ 6 }><Field name="State" component={ InputField } placeholder="State"/></Col>
                          <Col sm={ 6 }><Field name="Zip" component={ InputField } placeholder="Zip"/></Col>
                      </Row>
                      <Row><Col sm={ 12 }><label><Translate value="contact_person" /></label></Col></Row>
                      <Row>
                          <Col sm={ 6 }><Field name="FirstName" component={ InputField } placeholder="First Name"/></Col>
                          <Col sm={ 6 }><Field name="LastName" component={ InputField } placeholder="LastName"/></Col>
                      </Row>
                      <Row><Col sm={ 12 }><label><Translate value="email" /></label></Col></Row>
                      <Row>
                          <Col sm={ 12 }><Field name="Email" component={ InputField } placeholder="example@abc.com"/></Col>
                      </Row>
                      <Row>
                          <Col sm={ 6 }>
                              <Row><Col sm={ 12 }><label><Translate value="phone" /></label></Col></Row>
                              <Row>
                                  <Col sm={ 12 }><Field name="Telephone" component={ InputField } placeholder="123-456-7890"/></Col>
                              </Row>
                          </Col>
                          <Col sm={ 6 }>
                              <Row><Col sm={ 12 }><label><Translate value="mobile" /></label></Col></Row>
                              <Row>
                                  <Col sm={ 12 }><Field name="Cellphone" component={ InputField } placeholder="123-456-7890"/></Col>
                              </Row>
                          </Col>
                      </Row>
                      <Row><Col sm={ 12 }><label><Translate value="fax" /></label></Col></Row>
                      <Row>
                          <Col sm={ 12 }><Field name="Fax" component={ InputField } placeholder="123-456-7890"/></Col>
                      </Row>
                  </Col>
              </Row>

        )
    }

    render() {
        const { handleSubmit, closeG, submitting, pristine, valid } = this.props;
        return (
            <ContentWrapper>
                <form method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this)) } >
                      <br/>
                        <div className="pull-right">
                            { this.props.isCreating || this.props.isEditing && <Spinner/> }
                            { this.props.createError && <div className="alert alert-danger marginTopStyle" >{JSON.stringify(this.props.createError)}</div> }
                            { this.props.editError && <div className="alert alert-danger marginTopStyle" >{JSON.stringify(this.props.editError)}</div> }
                            <button action="submit" className="btn btn-primary buttonStyle" disabled={ submitting || pristine || !valid || !checkPermission("change_warehouse") } ><Translate value="save" /></button>
                            <button className="btn btn-danger buttonStyle" onClick={(event) => { event.preventDefault(); closeG(); } } ><Translate value="cancel" /></button>
                        </div>

                    { this.renderForm() }
                </form>
            </ContentWrapper>
        )
    }
}

export default withRouter(WarehouseForm)



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/warehouseForm.jsx